import { render, staticRenderFns } from "./CraftView.vue?vue&type=template&id=3bd58e92&scoped=true&"
import script from "./CraftView.vue?vue&type=script&lang=js&"
export * from "./CraftView.vue?vue&type=script&lang=js&"
import style0 from "./CraftView.vue?vue&type=style&index=0&id=3bd58e92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd58e92",
  null
  
)

export default component.exports